import create from 'zustand';
import {devtools} from 'zustand/middleware';
import {COLUMN_NAMES} from '../../../utils/constants';

/**
 * @param {any} userSettings
 * @return {*}
 */
export function createApplicationStore(userSettings) {
    return create(devtools(
        /**
         * @param {function(*)} set
         * @param {function(): any} get
         * @return {*}
         */
        (set, get) => ({
            userDateFormat: (userSettings.dateFormat || 'dd/MM/yyyy'),
            setUserDateFormat: (dateFormat) => set({userDateFormat: dateFormat}),

            userCurrencySeparator: (userSettings.separator || 'space'),
            setUserCurrencySeparator: (currencySeparator) => set({userCurrencySeparator: currencySeparator}),

            columnsToDisplay: (userSettings.columnsToDisplay && userSettings.columnsToDisplay.length > 0) ? userSettings.columnsToDisplay : Object.values(COLUMN_NAMES),
            setColumnsToDisplay: (columnsToDisplay) => set({columnsToDisplay: columnsToDisplay}),
        })));
}
